import MainLayout from '@components/MainLayout/MainLayout'
import Layout from '@components/ItemPage/Layout'
import Modals from '@components/ItemPage/Modals'
import RelatedAuctions from '@components/ItemPage/RelatedAuctions'
import Details from '@components/ItemPage/Details'
import Images from '@components/ItemPage/Images'
import ItemPageProvider from '@components/ItemPage/Layout/ItemPageContext'

const ItemDetail = ({
  auction,
  auctionItem,
  relatedAuctions,
  itemId,
  allOffers,
  fetchItemUrl,
  pageNumber,
}: any) => {
  const { title, pictures, description } = auctionItem
  return (
    <ItemPageProvider
      auctionItem={auctionItem}
      allOffers={allOffers}
      itemId={itemId}
      fetchItemUrl={fetchItemUrl}
      auction={auction}
      pageNumber={pageNumber}
    >
      <MainLayout
        title={title}
        previewImage={pictures ? pictures[0] : null}
        previewDescription={description}
        hideOverflow={false}
      >
        <Layout>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2">
            <Images />
            <Details />
          </div>
          <RelatedAuctions relatedAuctions={relatedAuctions} />
        </Layout>
      </MainLayout>
      <Modals />
    </ItemPageProvider>
  )
}

export default ItemDetail
